module.exports = __webpack_public_path__ + "img/spring_mass_system.85ac8325.png";